// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__IFYGF","unreadBadge":"styles_unreadBadge__2M3B7","modalContent":"styles_modalContent__2_vFv","modal":"styles_modal__XpsZS"};